const pemMapping = {
    "41px": "41px",
    "34px": "34px",
    "28px": "28px",
    "25px": "25px",
    "22px": "22px",
    "20px": "20px",
    "18px": "18px",
    "17px": "17px",
    "16px": "16px",
    "15px": "15px",
    "14px": "14px",
    "13px": "13px",
    "12px": "12px",
    "10px": "10px",
    "none": "none"
};
var pem_mapping = Object.freeze(pemMapping);

export { pem_mapping as default };
//# sourceMappingURL=pem_mapping.js.map
